import { DomainConfig } from './types';

import messageReducer from './slices/messageSlice';
import languageReducer from './slices/languageSlice';
import dynamicReducer from './slices/dynamicSlice';
import feedReducer from './slices/feedSlice';
import rolesReducer from './slices/rolesSlice';
import subscriptionReducer from './slices/subscriptionSlice';
import userReducer from './slices/userSlice';
import authorizationReducer from './slices/authorizationSlice';
import notificationReducer from './slices/notificationSlice';

import configurationReducer from '../../domains/configuration/infrastructure/slices/configurationSlice';

import { userApi } from '../../services/user';
import { configurationApi } from '../../services/configuration';
import { systemApi } from '../../services/system';
import { settingsApi } from '../../domains/settings/infrastructure/api/settings.api';
import { clientsApi } from '../../domains/clients/infrastructure/api/clients.api';
import { stockOwnersApi } from '../../domains/clients/infrastructure/api/stock-owners.api';
import { channelsApi } from '../../domains/clients/infrastructure/api/channels.api';
import { notificationsApi } from '../../domains/notifications/infrastructure/api/notifications.api';
import { inboxApi } from '../../domains/inbox/infrastructure/api/inbox.api';
import { aiPromptsApi } from '../../domains/ai/infrastructure/api/aiPrompts.api';
import { adminsApi } from '../../domains/admins/infrastructure/api/admins.api';

export const domainRegistry: DomainConfig[] = [
  { name: 'authorization', reducer: authorizationReducer },
  { name: 'user', reducer: userReducer },
  { name: 'message', reducer: messageReducer },
  { name: 'subscription', reducer: subscriptionReducer },
  { name: 'feed', reducer: feedReducer },
  { name: 'dynamic', reducer: dynamicReducer },
  { name: 'roles', reducer: rolesReducer },
  { name: 'language', reducer: languageReducer },
  { name: 'notification', reducer: notificationReducer },
  { name: 'configuration', reducer: configurationReducer },

  {
    name: userApi.reducerPath,
    reducer: userApi.reducer,
    middleware: [userApi.middleware],
  },
  {
    name: configurationApi.reducerPath,
    reducer: configurationApi.reducer,
    middleware: [configurationApi.middleware],
  },
  {
    name: systemApi.reducerPath,
    reducer: systemApi.reducer,
    middleware: [systemApi.middleware],
  },
  {
    name: settingsApi.reducerPath,
    reducer: settingsApi.reducer,
    middleware: [settingsApi.middleware],
  },
  {
    name: clientsApi.reducerPath,
    reducer: clientsApi.reducer,
    middleware: [clientsApi.middleware],
  },
  {
    name: stockOwnersApi.reducerPath,
    reducer: stockOwnersApi.reducer,
    middleware: [stockOwnersApi.middleware],
  },
  {
    name: channelsApi.reducerPath,
    reducer: channelsApi.reducer,
    middleware: [channelsApi.middleware],
  },
  {
    name: notificationsApi.reducerPath,
    reducer: notificationsApi.reducer,
    middleware: [notificationsApi.middleware],
  },
  {
    name: inboxApi.reducerPath,
    reducer: inboxApi.reducer,
    middleware: [inboxApi.middleware],
  },
  {
    name: aiPromptsApi.reducerPath,
    reducer: aiPromptsApi.reducer,
    middleware: [aiPromptsApi.middleware],
  },
  {
    name: adminsApi.reducerPath,
    reducer: adminsApi.reducer,
    middleware: [adminsApi.middleware],
  },
];
